module.exports = __webpack_public_path__ + "img/cdj.0eb7db8c.png";